/**
 * Le menu « Planning » (ADR-0016, lot U6) : il mène au planning des interventions, mais reste allumé sur toutes les pages
 * du groupe (fiche de préparation, préparer l'année) — le lien ne pointe que vers la première, donc l'état actif se lit sur
 * le préfixe de l'adresse et non sur l'adresse exacte du lien.
 */
export const ADRESSE_PLANNING = '/planning/interventions';

/** Vrai pour `/planning` et toute adresse en dessous (`/planning/preparation`, `/planning/annee`…), jamais pour `/planningxyz`. */
export function planningActif(chemin: string): boolean {
  return chemin === '/planning' || chemin.startsWith('/planning/');
}

/**
 * L'ancienne adresse `/planning` (favoris, liens d'avant) redirige vers le planning des interventions EN CONSERVANT la
 * chaîne de requête : `/planning?semaine=2026-10-19` doit atterrir sur la même semaine.
 */
export function adresseRedirectionPlanning(recherche: string): string {
  return `${ADRESSE_PLANNING}${recherche}`;
}
